<script setup lang="ts">
import type { ContractClauseV2Dto } from '@/openapi';

import type { PaginatedDataTableCellProps } from './templateTypes';

/***
 * template to show array of areas
 */
const props = defineProps<PaginatedDataTableCellProps<ContractClauseV2Dto[]>>();
</script>

<template>
  <ExpandableCell v-if="props.cell?.length" :data-key="props.dataKey" :field="props.column.field">
    <!-- Collapsed content -->
    <template #collapsed>
      <div class="space-y-1">
        <div class="flex gap-2">
          <div>{{ props.cell[0]?.clauseSchema?.name }}</div>
          <div v-if="props.cell.length > 1">[...]</div>
        </div>
      </div>
    </template>

    <!-- Expanded content -->
    <template #expanded>
      <div class="flex flex-col gap-2">
        <div v-for="arrayValue in props.cell" :key="arrayValue.id">
          <div>
            {{ arrayValue.clauseSchema.name }}
          </div>
        </div>
      </div>
    </template>
  </ExpandableCell>
</template>
